export const sources = {
	webp: "__VITE_ASSET__P4DPfwIRieI8P6q8r4JZRw__ 400w, __VITE_ASSET__cn7IAAGY294pWGc7MpElVg__ 600w"
};
export const img = {
	src: "__VITE_ASSET__cn7IAAGY294pWGc7MpElVg__",
	w: 600,
	h: 800
};
export default {
	sources: sources,
	img: img
};
